import type { AddressOption } from '@/types/buy';

export interface AddressSelectItem {
  readonly value: string;
  readonly label: string;
  readonly option: AddressOption;
}

// Разделитель ключа — управляющий символ, не встречающийся в адресах/названиях (без склейки полей).
const KEY_SEP = String.fromCharCode(1);

// Уникальный ключ опции адреса для Mantine Select. Поиск адреса (/order/address/search) может вернуть
// НЕСКОЛЬКО разных базисов с ОДИНАКОВОЙ строкой адреса (разные title/тип — напр. «село Романовка»
// как точка КФХ «Крецу И.И.» и как населённый пункт «село Романовка»). value по одному `address`
// коллизирует → Mantine роняет дропдаун («Duplicate options are not supported»). Ключ из address+title
// различает разные базисы и схлопывает точные дубли (одинаковые address+title визуально неразличимы,
// дают одинаковые данные формы). basisId у результатов поиска нет, в ключ не входит. Работает и для
// опции, и для уже выбранного адреса (контролируемое value Select).
export function addressOptionKey(o: { readonly address: string; readonly title?: string }): string {
  return `${o.address}${KEY_SEP}${o.title ?? ''}`;
}

/** Опции Select из результатов поиска адреса: уникальные value, точные дубли схлопнуты (первый выигрывает). */
export function buildAddressOptions(options: readonly AddressOption[]): AddressSelectItem[] {
  const byKey = new Map<string, AddressSelectItem>();
  for (const option of options) {
    const value = addressOptionKey(option);
    if (!byKey.has(value)) {
      byKey.set(value, {
        value,
        label: option.title ? `${option.title} — ${option.address}` : option.address,
        option,
      });
    }
  }
  return [...byKey.values()];
}
